/* Fashion CITY — 스타일 버튼을 쇼피파이 옵션(가격)과 연결
   ─────────────────────────────────────────────────────────────
   스타일마다 가격이 다른 상품에서만 켜집니다.
   해당 상품 자료 파일(예: fc-po-tee.js)에 이 줄을 넣으면 켜집니다.

       variantOption: 'Style'

   그러면 :
     1) 테마가 원래 그리는 'Style' 선택 줄은 숨깁니다 (중복이라서)
     2) 손님이 우리 스타일 버튼을 누르면 그 옵션이 같이 눌려서
        가격이 바로 그 스타일 가격으로 바뀝니다.

   스타일 이름과 쇼피파이 옵션 값이 다르면, 그 스타일에
       variantValue: '쇼피파이에 적힌 값'
   을 넣어 주세요. 없으면 스타일 이름(n)을 그대로 씁니다.

   ※ 이 파일은 fc-po.js 다음에 실행됩니다.
*/
(function () {
  'use strict';

  var cfgEl = document.getElementById('fc-po-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var STY = (window.FCPO_STYLES || {})[CFG.handle];
  if (!STY || !STY.variantOption || !STY.styles || !STY.styles.length) return;

  // 테마가 만드는 라디오 이름은  ...-<옵션이름>-option  으로 끝납니다.
  var KEY = '-' + String(STY.variantOption).toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-option';
  var ROWSEL = '.option-selector, .selector-wrapper, .product-block--options, fieldset';

  function radios() {
    return Array.prototype.slice.call(
      document.querySelectorAll('input[type=radio][name$="' + KEY + '"]')
    );
  }

  function hideRow(list) {
    for (var i = 0; i < list.length; i++) {
      var row = list[i].closest ? list[i].closest(ROWSEL) : null;
      if (row && row.style.display !== 'none') row.style.display = 'none';
    }
  }

  function wantedValue() {
    var picked = document.querySelector('input[name=fcpo-style]:checked');
    var idx = picked ? (parseInt(picked.value, 10) || 0) : 0;
    var st = STY.styles[idx];
    if (!st) return '';
    return st.variantValue || st.n;
  }

  function sync() {
    var list = radios();
    if (!list.length) return;
    hideRow(list);
    var want = wantedValue();
    if (!want) return;
    for (var i = 0; i < list.length; i++) {
      if (list[i].value !== want) continue;
      if (!list[i].checked) {
        list[i].checked = true;
        list[i].dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'fcpo-style') sync();
  });

  // 테마가 옵션 줄을 다시 그릴 때가 있어서 계속 확인합니다 (아주 가볍습니다).
  sync();
  setInterval(sync, 800);
  window.addEventListener('load', sync);
})();